<ng-container [ngSwitch]="chartDisplayType">
   <qmg-vertical-bar-chart
      #chart
      *ngSwitchCase="ChartDisplayType.VerticalBar"
      [barPadding]="barPadding"
      [dataLabelFormatting]="dataLabelFormatting"
      [legend]="legend"
      [legendPosition]="legendPosition"
      [lineYAxisLabel]="lineYAxisLabel"
      [maxXAxisTickLength]="maxXAxisTickLength"
      [noBarWhenZero]="noBarWhenZero"
      [referenceLines]="referenceLines"
      [results]="data"
      [rotateXAxisTicks]="rotateXAxisTicks"
      [scheme]="colorScheme"
      [seriesData]="seriesData"
      [showDataLabel]="showDataLabel"
      [showVerticalBarLabels]="showVerticalBarLabels"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [verticalBarLabelFormatting]="verticalBarLabelFormatting"
      [view]="view"
      [lineChartViewHeight]="view !== undefined ? view[1] - 110 : undefined"
      [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel"
      [yAxisTickFormatting]="yAxisTickFormatting"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)"
      (select)="onSelect($event)"
   >
      <ng-template *ngIf="customTooltipTemplateRef" #tooltipTemplate let-model="model">
         <ng-container *ngTemplateOutlet="customTooltipTemplateRef; context: { model: this.model }"></ng-container>
      </ng-template>
   </qmg-vertical-bar-chart>
   <qmg-horizontal-bar-chart
      #chart
      *ngSwitchCase="ChartDisplayType.HorizontalBar"
      [legend]="legend"
      [legendPosition]="legendPosition"
      [maxXAxisTickLength]="maxXAxisTickLength"
      [noBarWhenZero]="noBarWhenZero"
      [referenceLines]="referenceLines"
      [results]="data"
      [rotateXAxisTicks]="rotateXAxisTicks"
      [scheme]="colorScheme"
      [showDataLabel]="showDataLabel"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [view]="view"
      [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)"
      (select)="onSelect($event)"
   >
      <ng-template *ngIf="customTooltipTemplateRef" #tooltipTemplate let-model="model">
         <ng-container *ngTemplateOutlet="customTooltipTemplateRef; context: { model: this.model }"></ng-container>
      </ng-template>
   </qmg-horizontal-bar-chart>
   <qmg-line-chart
      #chart
      *ngSwitchCase="ChartDisplayType.VerticalLine"
      [colorScheme]="colorScheme"
      [curve]="curve"
      [data]="data"
      [legend]="legend"
      [legendPosition]="legendPosition"
      [maxXAxisTickLength]="maxXAxisTickLength"
      [referenceLines]="referenceLines"
      [rotateXAxisTicks]="rotateXAxisTicks"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [timeline]="false"
      [view]="view"
      [xAxisLabel]="xAxisLabel"
      [xAxisTickFormatting]="xAxisTickFormatting"
      [yAxisLabel]="yAxisLabel"
      [xScaleMin]="xScaleMin"
      [xScaleMax]="xScaleMax"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)"
      (select)="onSelect($event)"
   >
      <ng-template *ngIf="customTooltipTemplateRef" #tooltipTemplateRef let-model="model">
         <ng-container *ngTemplateOutlet="customTooltipTemplateRef; context: { model: this.model }"></ng-container>
      </ng-template>
      <ng-template *ngIf="customSeriesTooltipTemplateRef" #seriesTooltipTemplateRef let-model="model">
         <ng-container
            *ngTemplateOutlet="customSeriesTooltipTemplateRef; context: { model: this.model }"
         ></ng-container>
      </ng-template>
   </qmg-line-chart>
   <qmg-pie-chart
      #chart
      *ngSwitchCase="ChartDisplayType.Pie"
      [colorScheme]="colorScheme"
      [data]="data"
      [doughnut]="doughnut"
      [explodeSlices]="explodeSlices"
      [labels]="labels"
      [legend]="legend"
      [legendPosition]="legendPosition"
      [view]="view"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)"
      (select)="onSelect($event)"
   >
      <ng-template *ngIf="customTooltipTemplateRef" #tooltipTemplateRef let-model="model">
         <ng-container *ngTemplateOutlet="customTooltipTemplateRef; context: { model: this.model }"></ng-container>
      </ng-template>
   </qmg-pie-chart>
   <qmg-pie-grid-chart
      #chart
      *ngSwitchCase="ChartDisplayType.PieGrid"
      [colorScheme]="colorScheme"
      [customLabel]="customLabel"
      [data]="data"
      [displayPieGridIndividualPies]="displayPieGridIndividualPies"
      [doughnut]="doughnut"
      [explodeSlices]="explodeSlices"
      [labels]="labels"
      [legend]="legend"
      [legendPosition]="legendPosition"
      [view]="view"
      [canClickPieInGridCb]="canClickPieInGridCb"
      (activate)="onActivate($event)"
      (chartClick)="onClick($event)"
      (deactivate)="onDeactivate($event)"
      (select)="onSelect($event)"
      ><ng-template *ngIf="customTooltipTemplateRef" #tooltipTemplateRef let-model="model">
         <ng-container *ngTemplateOutlet="customTooltipTemplateRef; context: { model: this.model }"></ng-container>
      </ng-template>
   </qmg-pie-grid-chart>
</ng-container>
